import { css } from 'styled-components';
import { colors } from '../../style';
import { avatarsColors } from '../../style/colors';

const variants = {
  white: css`
    background: ${colors.white};
    color: ${colors.gray900};
  `,
  gray400: css`
    background: ${colors.gray400};
    color: ${colors.gray900};
  `,
  gray100: css`
    background: ${colors.gray100};
    color: ${colors.gray900};
  `,
  'white-action': css`
    background: ${colors.white};
    border: 1px solid ${props => props.theme.actionColor};
    color: ${props => props.theme.actionColor};
  `,
  'white-border-secondary': css`
    background: ${colors.white};
    border: 1px solid ${colors.gray600};
    color: ${colors.gray600};
  `,
  action: css`
    background: ${props => props.theme.actionColor};
  `,
  'action-white-border': css`
    background: ${props => props.theme.actionColor};
    border: 2px solid white;
  `,
  darkIndigo: css`
    background: ${avatarsColors.darkIndigo};
  `,
  darkPurple: css`
    background: ${avatarsColors.darkPurple};
  `,
  sofiaPink: css`
    background: ${avatarsColors.sofiaPink};
  `,
  darkRed: css`
    background: ${avatarsColors.darkRed};
  `,
  darkOrange: css`
    background: ${avatarsColors.darkOrange};
  `,
  eggYolk: css`
    background: ${avatarsColors.eggYolk};
    color: ${colors.gray900};
  `,
  saladish: css`
    background: ${avatarsColors.saladish};
    color: ${colors.gray900};
  `,
  grassGreen: css`
    background: ${avatarsColors.grassGreen};
  `,
  navy: css`
    background: ${avatarsColors.navy};
  `,
  brightBlue: css`
    background: ${avatarsColors.brightBlue};
    color: ${colors.gray900};
  `,
};

const sizes = {
  xxs: {
    width: '24px',
    height: '24px',
    fontSize: '0.5rem',
    fallbackIconSize: 'sm',
  },
  xs: {
    width: '32px',
    height: '32px',
    fontSize: '0.875rem',
    fallbackIconSize: 'md',
  },
  sm: {
    width: '40px',
    height: '40px',
    fontSize: '1rem',
    fallbackIconSize: 'lg',
  },
  md: {
    width: '48px',
    height: '48px',
    fontSize: '1.125rem',
    fallbackIconSize: 'xl',
  },
  lg: {
    width: '64px',
    height: '64px',
    fontSize: '1.375rem',
    fallbackIconSize: 'xxl',
  },
  xl: {
    width: '80px',
    height: '80px',
    fontSize: '1.625rem',
    fallbackIconSize: '2xxl',
  },
  xxl: {
    width: '112px',
    height: '112px',
    fontSize: '2.8rem',
    fallbackIconSize: '3xxl',
  },
} as const;

const badge = {
  placements: {
    'top-right': css`
      right: -4px;
      top: -2px;
    `,
    'bottom-right': css`
      right: -2px;
      bottom: 0;
    `,
    'top-left': css`
      left: -4px;
      top: -2px;
    `,
    'bottom-left': css`
      left: -2px;
      bottom: 0;
    `,
  },
};

const badgeRatios = {
  size: 2.5,
  icon: 1.2,
};

export { sizes, variants, badge, badgeRatios };
